import {Component} from "react";
import React from "react";
import {Box, ButtonBase} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";
import GF from "../../../../lib/utils/GF";

class BaseTab extends Component {

  constructor(props) {
    super(props);
    this.state = {
      removeActive: false
    };
  }

  onTabClick(id, event, mode) {
    if (!mode) {
      if (!this.state.removeActive && GF.checkNotNull(this.props.onTabClick)) {
        this.props.onTabClick(this.props.id, event);
      }
      this.state.removeActive = false;
    } else {
      this.onRemoveClick(event, id);
    }
  }

  onRemoveClick(event, id) {
    this.state.removeActive = true;
    if (GF.checkNotNull(this.props.onRemoveClick)) {
      this.props.onRemoveClick(this.props.id);
    }
  }

  render() {
    return <ButtonBase disableRipple>
      <Box
        onClick={(event) => this.onTabClick(this.props.id, event, false)}
        onAuxClick={(event) => {
          if (!this.props.notClosable && event.button === 1) {
            event.preventDefault();
            this.onTabClick(this.props.id, event, true);
            //console.log("Mittlere Maustaste");
          }
        }}
        selected={this.props.id === this.props.activeTabId}
        sx={{
          margin: '0px 5px 5px 0px',
          padding: '12px 16px',
          cursor: 'pointer',
          backgroundColor: this.props.id === this.props.activeTabId ? 'var(--color-black-804)' : 'var(--color-primary)',
          color: this.props.id === this.props.activeTabId ? 'var(--color-white)' : 'var(--color-black)',
          fontFamily: ['cn-roboto-slab-medium', 'sans-serif'],
          borderRadius: '0px 8px 0px 0px',
          '&:hover': {
            backgroundColor: 'var(--color-secondary)', color: 'var(--color-white)',
          },
        }}
      >
        <HorizontalLayout className='justify-between'>
          {this.props.tabTitle}
          {!this.props.notClosable ? <CloseIcon className="ml-[4px] mr-0" onClick={(event) => this.onRemoveClick(this.props.id, event)}/> : <></>}
        </HorizontalLayout>
      </Box>
    </ButtonBase>;
  }
}

BaseTab.propTypes = {
  id: PropTypes.number,
  tabTitle: PropTypes.string,
  activeTabId: PropTypes.number,
  onTabClick: PropTypes.func,
  onRemoveClick: PropTypes.func,
  notClosable: PropTypes.bool
};
export default BaseTab;
